import React, { useContext, useCallback } from 'react';
import { createPortal } from 'react-dom';
import clsx from 'clsx';
import { v4 } from 'uuid';
import { Context } from '../stateManagement/store';
import useActionsHook from '../stateManagement/actions';
import '../styles/app.scss';
import NotConnected from './NotConnected';
import Connected from './Connected';

const uuid = crypto.randomUUID?.() || v4();
const modalRoot = document.createElement('div');
modalRoot.id = crypto.randomUUID?.() || v4();
document.body.appendChild(modalRoot);

const Modal = () => {
  const { dispatch, state } = useContext(Context);

  const actions = useActionsHook(dispatch);
  const { isModalOpen, account } = state;

  const handleOverlayClick = useCallback((e) => {
    if (e.target.id === uuid) {
      actions.closeModal(!!account);
    }
  }, [actions, account]);

  return createPortal(
    <div className={clsx('web3-wallet-connector', { open: isModalOpen })}>
      <div className="web3-wc_modal_overlay" onClick={handleOverlayClick} id={uuid}>
        <div className={clsx('web3-wc_modal_container', { connected: !!account })}>
          <div className="web3-wc_modal_body">
            {account ? <Connected /> : <NotConnected />}
          </div>
        </div>
      </div>
    </div>,
    modalRoot,
  );
};

export default Modal;
